/**
 * コンテンツフィールドの名前からIDを取得します。
 *
 * @param {string} label - 検索したいコンテンツフィールドの名前
 * @returns {number|undefined} - コンテンツフィールドのID。見つからない場合はundefinedを返す
 */
export function getContentFieldIdByLabel(label) {
    if (
        typeof window.mtappVars === 'undefined' ||
        typeof window.mtappVars.contentType === 'undefined' ||
        typeof window.mtappVars.contentType.fields === 'undefined'
    ) {
        return;
    }

    const field = window.mtappVars.contentType.fields.find((f) => f.label === label);

    if (!field) {
        alert('該当するIDが存在しません。');
        return;
    }

    return field.id;
}
